import {inject} from "@angular/core";
import {EventBusService} from "@aiknow-srl/aik-ngx-eventbus";
import {LogoutEvent} from "../events/LogoutEvent";

export abstract class BaseTinyService {

  protected extEventBus: EventBusService = inject(EventBusService);

  constructor() {
    this.extEventBus.on(LogoutEvent.NAME, () => {
      this.cleanupServiceFields();
    });
  }

  abstract cleanupServiceFields(): void;
}
